import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-[#0a0a0a]" data-id="element-842">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl py-20" data-id="element-843">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-844">
          <h1 className="text-3xl md:text-4xl font-medium text-white mb-4 tracking-tight" data-id="element-845">
            Términos y Condiciones
          </h1>
          <p className="text-gray-400 text-sm mb-12" data-id="element-846">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            month: 'long',
            year: 'numeric'
          })}
          </p>

          <div className="space-y-10 text-gray-300 text-[15px] leading-relaxed" data-id="element-847">
            <section data-id="element-848">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-849">1. Objeto</h2>
              <p data-id="element-850">
                Los presentes Términos y Condiciones regulan el uso de los
                servicios ofrecidos por Growthly LLC (en adelante, "Growthly" o
                "la Agencia") a través de su sitio web, así como las condiciones
                de contratación de los servicios de diseño, desarrollo web y
                creación de ecosistemas digitales para empresas.
              </p>
            </section>

            <section data-id="element-851">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-852">
                2. Servicios contratados
              </h2>
              <p className="mb-4" data-id="element-853">
                Growthly ofrece servicios integrales de presencia digital, que
                incluyen, pero no se limitan a:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-854">
                <li data-id="element-855">Diseño y desarrollo de páginas web profesionales.</li>
                <li data-id="element-856">Creación de menús y cartas digitales interactivas.</li>
                <li data-id="element-857">
                  Sincronización y optimización de perfiles en redes sociales.
                </li>
                <li data-id="element-858">Consultoría estratégica digital.</li>
              </ul>
              <p className="mt-4" data-id="element-859">
                Las especificaciones exactas de cada proyecto se detallarán en
                la propuesta comercial aceptada por el cliente.
              </p>
            </section>

            <section data-id="element-860">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-861">
                3. Precio y forma de pago
              </h2>
              <p className="mb-4" data-id="element-862">
                El precio de nuestro servicio estándar de ecosistema digital es
                de <strong data-id="element-863">350€</strong> (impuestos incluidos, salvo indicación
                contraria). Este pago se divide en dos fases:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-864">
                <li data-id="element-865">
                  <strong data-id="element-866">Fase 1 (Reserva):</strong> Un pago inicial de 50€ para
                  reservar el proyecto y comenzar los trabajos de forma
                  inmediata.
                </li>
                <li data-id="element-867">
                  <strong data-id="element-868">Fase 2 (Entrega):</strong> Un pago final de 300€ a la
                  finalización y entrega del proyecto.
                </li>
              </ul>
              <p className="mt-4" data-id="element-869">
                Los pagos se realizarán a través de los métodos habilitados en
                nuestra plataforma (PayPal, transferencia bancaria, etc.).
              </p>
            </section>

            <section data-id="element-870">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-871">
                4. Plazos de entrega
              </h2>
              <p data-id="element-872">
                Los plazos de entrega se acordarán de forma individualizada con
                cada cliente tras el abono de la reserva inicial. Growthly se
                compromete a cumplir los plazos establecidos, siempre y cuando
                el cliente proporcione el material y la información necesaria
                (textos, imágenes, accesos) en los tiempos requeridos. Los
                retrasos imputables al cliente modificarán proporcionalmente la
                fecha de entrega final.
              </p>
            </section>

            <section data-id="element-873">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-874">
                5. Obligaciones del cliente
              </h2>
              <p className="mb-4" data-id="element-875">El cliente se compromete a:</p>
              <ul className="list-disc pl-5 space-y-2 text-gray-400" data-id="element-876">
                <li data-id="element-877">Proporcionar información veraz y completa.</li>
                <li data-id="element-878">
                  Entregar los materiales necesarios para el desarrollo del
                  proyecto en los plazos acordados.
                </li>
                <li data-id="element-879">
                  Abonar los importes correspondientes en las fechas
                  estipuladas.
                </li>
                <li data-id="element-880">
                  Garantizar que posee los derechos de autor o licencias de uso
                  de cualquier material (imágenes, textos, logotipos)
                  proporcionado a la Agencia.
                </li>
              </ul>
            </section>

            <section data-id="element-881">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-882">
                6. Propiedad intelectual
              </h2>
              <p data-id="element-883">
                Una vez abonado el 100% del importe del proyecto, el cliente
                adquiere los derechos de explotación sobre el producto final
                entregado (página web, diseños). Growthly se reserva el derecho
                de mostrar el proyecto en su portfolio, casos de éxito y
                material promocional, salvo que se firme un acuerdo de
                confidencialidad (NDA) específico.
              </p>
            </section>

            <section data-id="element-884">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-885">
                7. Responsabilidad
              </h2>
              <p data-id="element-886">
                Growthly no se hace responsable de las caídas de servidores de
                terceros (hosting), problemas con proveedores de dominio, o
                cambios en los algoritmos de plataformas externas (Google, Meta)
                que puedan afectar al rendimiento del ecosistema digital una vez
                entregado.
              </p>
            </section>

            <section data-id="element-887">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-888">
                8. Cancelaciones y reembolsos
              </h2>
              <p data-id="element-889">
                El cliente tiene derecho a la devolución íntegra de la reserva
                inicial (50€) si decide cancelar el proyecto antes de la
                presentación de la primera propuesta de diseño. Una vez
                presentados los primeros trabajos o propuestas, la reserva
                inicial no será reembolsable, ya que cubre los gastos operativos
                y de consultoría inicial.
              </p>
            </section>

            <section data-id="element-890">
              <h2 className="text-xl font-medium text-white mb-4" data-id="element-891">
                9. Legislación aplicable
              </h2>
              <p data-id="element-892">
                Estos Términos y Condiciones se rigen por la legislación
                española. Para la resolución de cualquier controversia que
                pudiera derivarse de la prestación de los servicios, las partes
                se someten a los Juzgados y Tribunales competentes.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>;
}